import React from "react";
import "../style/services.css";
import castle from "../assets/castle.png";
import people from "../assets/people.png";
import car from "../assets/car.png";
import servicesimage1 from "../assets/servicesimage1.jpg";
import { NavLink } from "react-router-dom";
import head from "../assets/head.png";
import mental from "../assets/mental.png";
import wheel from "../assets/wheel.png";
import box from "../assets/box.png";
import searchbox from "../assets/searchbox.png";
import inlove from "../assets/inlove.png";
import mark from "../assets/mark.png";
import ContentBlock from "./ContentBlock";

const Services = () => {
  return (
    <div className="service-container">
      <section className="services-section1">
        <h1>Our Care Services</h1>
        <h4>
          Comprehensive residential care
          <br /> services designed to support individuals with <br /> learning
          disabilities, mental health challenges, and physical disabilities.
        </h4>
      </section>
      <section className="services-section2">
        <div className="">
          <h1>Primary Care Services</h1>
          <h5>
            Our core services are designed to meet the diverse needs of
            <br />
            individuals requiring residential care and support.
          </h5>
        </div>

        <div className="services-section2-div">
          <div
            className="services-section2-div-item1"
            style={{ marginTop: "50px" }}
          >
            <img src={castle} alt="castle" loading="lazy" />
            <h3 style={{ padding: "0" }}>24/7 Residential Care</h3>
            <h4>
              Comprehensive residential care <br />
              providing round-the-clock support with <br /> daily living,
              medication management, <br /> and personal care.
            </h4>
          </div>
          <div className="services-section2-div-item2">
            <h4>What's Included:</h4>
            <ul className="two-column-list" style={{ listStyle: "inherit" }}>
              <li> Regular health monitoring</li>
              <li>Medication administration</li>
              <li>Personal care and hygiene support</li>
              <li>Companionship and emotional support</li>
              <li>Meal planning and nutritional support</li>
              <li>Assistance with daily living activities</li>
            </ul>
          </div>
        </div>
        <div className="services-section2-div">
          <div
            className="services-section2-div-item1"
            style={{ marginTop: "50px" }}
          >
            <img src={people} alt="people" loading="lazy" />
            <h3 style={{ padding: "0" }}>Respite Care</h3>
            <h4>
              Short-term care giving families and
              <br /> primary carers a well-deserved break
              <br /> while ensuring continuity of excellent
              <br /> care.
            </h4>
          </div>
          <div className="services-section2-div-item2">
            <h4>What's Included:</h4>
            <ul className="two-column-list">
              <li>Familiar care routines maintained</li>{" "}
              <li> Professional assessment and care planning</li>
              <li>Social activities and engagement</li>
              <li>Regular family updates and communication</li>
              <li> Emergency respite availables</li>
              <li>Flexible duration from days to weeks</li>
            </ul>
          </div>
        </div>
        <div className="services-section2-div">
          <div
            className="services-section2-div-item1"
            style={{ marginTop: "50px" }}
          >
            <img src={car} alt="car" loading="lazy" />
            <h3 style={{ padding: "0" }}>Emergency Placement</h3>
            <h4>
              Immediate placement services available
              <br /> for urgent care needs with
              <br />
              comprehensive professional
              <br /> assessment.
            </h4>
          </div>
          <div className="services-section2-div-item2">
            <h4>What's Included:</h4>
            <ul className="two-column-list">
              <li>24-hour emergency response</li>
              <li>Temporary and permanent options</li>
              <li> Family liaison and communication</li>
              <li>Rapid assessment and placement</li>
              <li>Crisis intervention support</li>
              <li>Transition planning and supports</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="services-section3">
        <h1>A Home-Like Environment</h1>
        <div className="services-section3-item2">
          <div className="services-section3-item2-sub1">
            <p>
              Our facilities are designed to feel like home while providing
              <br /> all the professional care and support needed. We believe
              <br />
              that environment plays a crucial role in well-being and
              <br /> quality of life.
            </p>
            <p>
              Each of our residences features comfortable common
              <br /> areas, accessible design, beautiful gardens, and all the
              <br />
              amenities needed for daily life and social activities.
            </p>
            <div className="section2-link">
              <NavLink to="/tour">Schedule a Tour</NavLink>
            </div>
          </div>
          <ContentBlock>
            <div className="services-section3-item2-sub2">
              <img src={servicesimage1} alt="servicesimage1" loading="lazy" />
            </div>
          </ContentBlock>
        </div>
      </section>
      <section className="services-section4">
        <div className="services-section4-div1">
          <h1>Conditions We Support</h1>
          <span>
            Specialized care and support for individuals with various
            conditions, always with a person-centered approach.
          </span>
        </div>
        <div className="services-section4-div2">
          <div className="services-section4-div2-items">
            <img src={head} alt="head" loading="lazy" />
            <h3>Learning Disabilities</h3>
            <h5>
              Specialized support for
              <br /> individuals with learning
              <br /> disabilities, promoting <br /> independence and skill
              <br /> development.
            </h5>
            <span className="span-with-color">
              <h3>Our Approach:</h3>
              <h5>
                Person-centered plans focusing <br /> on individual strengths
                and
                <br />
                goals.
              </h5>
            </span>
          </div>

          <div className="services-section4-div2-items">
            <img src={mental} alt="mental" loading="lazy" />
            <h3>Mental Health Challenges</h3>
            <h5>
              Professional mental health
              <br />
              support with therapeutic
              <br /> activities and medication
              <br />
              management.
            </h5>
            <span className="span-with-color">
              <h3>Our Approach:</h3>
              <h5>
                Collaborative care with mental
                <br /> health professionals and
                <br /> therapeutic interventions.
              </h5>
            </span>
          </div>

          <div className="services-section4-div2-items">
            <img src={wheel} alt="wheel" loading="lazy" />
            <h3>Physical Disabilities</h3>
            <h5>
              Accessible environments and
              <br /> specialized care supporting
              <br /> mobility, comfort, and
              <br /> independence.
            </h5>
            <span className="span-with-color">
              <h3>Our Approach:</h3>
              <h5>
                Adaptive equipment and
                <br /> physiotherapy support for
                <br /> optimal quality of life.
              </h5>
            </span>
          </div>
        </div>
      </section>
      <section className="services-section5">
        <h1>Additional Support Services</h1>
        <div className="services-section5-div1">
          <ul className="two-column-lists">
            <li> Individual care planning and regular reviews</li>
            <li> Community integration and social activities</li>
            <li>Therapeutic activities and mental health</li>
            <li> support Nutrition planning and dietary support</li>
            <li> Family support and communication services</li>
            <li>Educational and skill development programs</li>
            <li>Medical care coordination with healthcare professionals</li>
            <li>Transportation for appointments and activities</li>
          </ul>
        </div>
      </section>
      <section className="services-section6">
        <h1>Our Care Process</h1>
        <div className="services-section6-div1">
          <div className="services-section6-div1-items">
            <img src={mark} alt="mark" loading="lazy" />
            <h3>Initial Assessment</h3>
            <h5>
              Comprehensive
              <br /> evaluation of
              <br /> needs and
              <br /> preferences
            </h5>
          </div>
          <div className="services-section6-div1-items">
            <img src={inlove} alt="inlove" loading="lazy" />
            <h3>Care Planning</h3>
            <h5>
              Personalized care
              <br /> plan development <br />
              with family input
            </h5>
          </div>
          <div className="services-section6-div1-items">
            <img src={box} alt="box" loading="lazy" />
            <h3>Implementation</h3>
            <h5>
              Professional care
              <br /> delivery by
              <br /> trained staff
            </h5>
          </div>
          <div className="services-section6-div1-items">
            <img src={searchbox} alt="searchbox" loading="lazy" />
            <h3>Review & Adapt</h3>
            <h5>
              Regular reviews
              <br /> and plan
              <br /> adjustments as
              <br /> needed
            </h5>
          </div>
        </div>
      </section>

      <section className="services-section7">
        <div className="services-section7-div1">
          <h1>Learn More About Our Services</h1>
          <h3>
            Contact us today to discuss how our services can support you or your
            loved
            <br /> one. We're here to answer questions and provide guidance.
          </h3>
          <p>
            <div className="about-section5-div1-navs">
              <NavLink
                to="/contact-us"
                style={{ color: "rgba(27, 77, 88, 1)" }}
              >
                Contact Us Today
              </NavLink>
            </div>
            Tel:
            <a href="tel:+[234][81313843]" className="footer-link">
              0121 769 3243
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Services;
